import React from "react";
import { Navigate, Outlet } from "react-router";
import { useAuth } from "../hooks/auth";
import Loading from "../components/Loading/Loading";

export const RequireAuth = () => {
  const { isAuthenticated, isAuthLoading, user } = useAuth()!;

  if (isAuthLoading) {
    return <Loading fullPage message="Verifying session..." />;
  }

  if (!isAuthenticated)
    return <Navigate to="/login" replace />;

  // console.log('USER ROLE IN REQ AUTH', user, allowedRoles);

  // if(user && allowedRoles && !allowedRoles.includes(user.role)) 
  //   return <div>You do not have permission to view this page</div>

  return <Outlet />;
};
